import { Heading, SimpleGrid, Box, Container } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { ArrowDownIcon, ArrowUpIcon, ChevronRightIcon } from "@chakra-ui/icons";
import "react-calendar/dist/Calendar.css";
import { colors } from "../../theme/styles/colors";
import { useSelector } from "react-redux";
import SelectInput from "../../theme/components/input/select-input";
import { GRID_COLUMNS } from "../../core/utils/grid-columns";
import { CREATE_RESPONSE } from "../../core/utils/common-function";
import api from "../../core/api";
import Grid from "../../theme/components/grid/grid";
import { ROUTE_LINKS } from "../../core/utils/route-links";
import { MENU_NAMES } from "../../core/utils/constants";
import { useNavigate } from "react-router-dom";

const TeleCallerDashboard = () => {
  const selector = useSelector((_) => _);
  const activeCard = {
    borderRadius: "10px",
    fontWeight: "600",
    fontSize: "17px",
    overflow: "hidden",
    columns: { base: "1", sm: "1", md: "2", lg: "2" },
    backgroundColor: "rgb(255 255 255)",
    border: "1px solid #e9e9e9",
    paddingBottom: "0px",
  };
  const cardTitle = {
    paddingBottom: "10px",
    fontWeight: "300",
    color: colors.black,
    fontSize: "20px",
  };
  const [dashboardStats, setDashboardStats] = useState({
    activeFiles: 0,
    lastWeekActiveFiles: 0,
    percentageDifference: 0,
    isPositiveDifference: false,
    activeEnquiry: 0,
    convertedEnquiry: 0,
    fileAdmissioned: 0,
    fileLodged: 0,
    pendingFileAdmission: 0,
    pendingFileReady: 0,
    dailyEnquiries: [],
  });
  const [dailyEnquiries, setDailyEnquiries] = useState([]);
  const [apiPayload, setAPIPayload] = useState({
    filterBy: 1,
    branchId: selector.branch.userBranchId,
  });

  const onFilterChange = (val) => {
    setAPIPayload({
      ...apiPayload,
      filterBy: val,
    });
  };
  const getDashboardKPIs = () => {
    api
      .get(`Dashboard/get/${apiPayload.filterBy}/${apiPayload.branchId}`)
      .then((res) => {
        setDashboardStats(res.data.data);
        setDailyEnquiries(
          CREATE_RESPONSE(
            GRID_COLUMNS.DASHBOARD_ENQUIRIES,
            res.data.data.dailyEnquiries
          )
        );
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (
      apiPayload.branchId != "" &&
      apiPayload.branchId == selector.branch.userBranchId
    ) {
      getDashboardKPIs();
    } else {
      setAPIPayload({
        ...apiPayload,
        branchId: selector.branch.userBranchId,
      });
    }
  }, [apiPayload, selector.branch.userBranchId]);

  return (
    <Box width={"100%"}>
      <Container maxW="container.xll" marginTop={"20px"}>
        <SimpleGrid
          columns={{ base: "1", md: "1", lg: "0", lg: "0" }}
          gap={4}
          rowSpan={{ base: "1", md: "1", lg: "4", lg: "4" }}
        >
          <Box display="flex" alignItems={"center"} justifyContent={"end"}>
            <SelectInput
              width={"100px"}
              marginBottom={"0px"}
              formControl={{ id: "filterBy", variant: "floating" }}
              isRequired={false}
              box={{ marginBottom: 0 }}
              height={"48px"}
              isReadOnly={false}
              value={apiPayload.filterBy}
              name="filterBy"
              onChange={(e) => onFilterChange(e.target.value)}
              label={{
                text: "Filter By",
              }}
              options={[
                { text: "Today", value: 1 },
                { text: "Last Week", value: 2 },
                { text: "This Month", value: 3 },
                { text: "Last Month", value: 4 },
                { text: "This Year", value: 5 },
                { text: "Last Year", value: 6 },
              ]}
            />
          </Box>
          <Box colSpan={0} templateColumns="repeat(3, 3fr)">
            <SimpleGrid
              columns={{ base: "1", md: "2", lg: "4", lg: "4" }}
              gap={4}
              rowSpan={{ base: "1", md: "1", lg: "2", lg: "2" }}
            >
              <Box {...activeCard}>
                <Box padding={"20px"} minHeight={"153px"}>
                  <Box {...cardTitle}>Active Files</Box>
                  <Box display={"flex"}>
                    <Box
                      fontSize={"36px"}
                      fontWeight={"500"}
                      lineHeight={"52px"}
                    >
                      {dashboardStats.activeFiles}
                    </Box>
                    <Box
                      borderRadius={"10px"}
                      padding={"10px"}
                      marginLeft={"13px"}
                      fontSize={"12px"}
                      color={
                        dashboardStats.isPositiveDifference
                          ? "#38A169"
                          : "#ED4F9D"
                      }
                      backgroundColor={
                        dashboardStats.isPositiveDifference
                          ? "#C6F6D5"
                          : "#FDF2F8"
                      }
                    >
                      {dashboardStats.isPositiveDifference ? (
                        <ArrowUpIcon />
                      ) : (
                        <ArrowDownIcon />
                      )}
                      {dashboardStats.percentageDifference}%
                    </Box>
                  </Box>
                  <Box fontSize={"12px"} marginTop={"0px"}>
                    Last week {dashboardStats.lastWeekActiveFiles}
                  </Box>
                </Box>
              </Box>
              <Box {...activeCard}>
                <Box padding={"20px"} minHeight={"153px"}>
                  <Box {...cardTitle}>Monthly Reports</Box>
                  <Box display={"flex"} justifyContent={"space-between"}>
                    <Box fontSize={"14px"} fontWeight={"500"}>
                      Enquiries:
                    </Box>
                    <Box fontSize={"14px"} fontWeight={"500"}>
                      Converted:
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      display={"flex"}
                      justifyContent={"space-between"}
                      lineHeight={"52px"}
                    >
                      <Box
                        display={"flex"}
                        fontSize={"36px"}
                        fontWeight={"500"}
                        lineHeight={"52px"}
                      >
                        {dashboardStats.activeEnquiry}
                      </Box>
                      <Box
                        display={"flex"}
                        fontSize={"36px"}
                        fontWeight={"500"}
                        lineHeight={"52px"}
                      >
                        {dashboardStats.convertedEnquiry}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box {...activeCard}>
                <Box padding={"20px"} minHeight={"153px"}>
                  <Box {...cardTitle}>Filing Work Pending</Box>
                  <Box display={"flex"} justifyContent={"space-between"}>
                    <Box fontSize={"14px"} fontWeight={"500"}>
                      Admission:
                    </Box>
                    <Box fontSize={"14px"} fontWeight={"500"}>
                      Lodgement:
                    </Box>
                  </Box>
                  <Box>
                    <Box display={"flex"} justifyContent={"space-between"}>
                      <Box
                        display={"flex"}
                        fontSize={"36px"}
                        fontWeight={"500"}
                        lineHeight={"52px"}
                      >
                        {dashboardStats.fileAdmissioned}
                      </Box>
                      <Box
                        display={"flex"}
                        fontSize={"36px"}
                        fontWeight={"500"}
                        lineHeight={"52px"}
                      >
                        {dashboardStats.fileLodged}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box {...activeCard}>
                <Box padding={"20px"} minHeight={"153px"}>
                  <Box {...cardTitle}>Branch Work Pending</Box>
                  <Box display={"flex"} justifyContent={"space-between"}>
                    <Box fontSize={"14px"} fontWeight={"500"}>
                      Admission Docs:
                    </Box>
                    <Box fontSize={"14px"} fontWeight={"500"}>
                      File Ready:
                    </Box>
                  </Box>
                  <Box>
                    <Box display={"flex"} justifyContent={"space-between"}>
                      <Box
                        display={"flex"}
                        fontSize={"36px"}
                        fontWeight={"500"}
                        lineHeight={"52px"}
                      >
                        {dashboardStats.pendingFileAdmission}
                      </Box>
                      <Box
                        display={"flex"}
                        fontSize={"36px"}
                        fontWeight={"500"}
                        lineHeight={"52px"}
                      >
                        {dashboardStats.pendingFileReady}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </SimpleGrid>
          </Box>
        </SimpleGrid>
        <SimpleGrid
          columns={{ base: "1", md: "1", lg: "1", lg: "1" }}
          gap={4}
        ></SimpleGrid>

        <SimpleGrid
          columns={{ base: "1", md: "1", lg: "1", lg: "1" }}
          gap={4}
          rowSpan={{ base: "1", md: "1", lg: "2", lg: "2" }}
        >
          <Box
            borderRadius={"10px"}
            marginTop={"20px"}
            padding={"20px"}
            marginBottom={"20px"}
            border={"1px solid #e9e9e9"}
          >
            <Heading
              fontSize={"20px"}
              fontWeight={"300"}
              color={colors.black}
              marginTop={"0px"}
            >
              Today Enquiries
            </Heading>
            <Grid
              name={"daily_enquiries"}
              hasAction={false}
              hasColumnDrop={false}
              columns={GRID_COLUMNS.DASHBOARD_ENQUIRIES}
              data={dailyEnquiries}
            />
          </Box>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default TeleCallerDashboard;
